"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prizm = exports.createPrizmTheme = void 0;
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _colors = _interopRequireDefault(require("./colors"));
var _typography = _interopRequireDefault(require("./typography"));
var _spacing = _interopRequireDefault(require("./spacing"));
const menu = {
  expanded: '256px',
  collapsed: '48px'
};
const header = {
  height: '48px'
};
const createPrizmTheme = (primitives = {}, overrides = {}, extra = {}) => {
  const colors = (0, _lodash.default)(_colors.default, primitives.colors);
  const typography = (0, _lodash.default)(_typography.default, primitives.typography);
  const spacing = (0, _lodash.default)(_spacing.default, primitives.spacing);
  const theme = {
    name: 'prizm',
    fonts: {
      preferred: '"Museo Sans", "Verdana", sans-serif',
      secondary: '"HelveticaNeueLT Std Med Cn"'
    },
    fontSizes: {
      base: '1rem'
    },
    typography,
    spacing,
    AppFrame: {
      bellWidget: {
        width: '352px',
        boxShadow: 'rgba(0, 0, 0, 0.15) 0px 4px 6px 0px',
        header: {
          fontFamily: typography.bodyHeader.fontFamily,
          fontSize: typography.bodyHeader.fontSize,
          fontWeight: typography.bodyHeader.fontWeight,
          lineHeight: '40px',
          height: '40px',
          padding: `0 ${spacing.m1}`,
          textAlign: 'center',
          textTransform: 'capitalize'
        },
        footer: {
          fontFamily: typography.bodyShort.fontFamily,
          fontSize: typography.bodyShort.fontSize,
          fontWeight: typography.bodyShort.fontWeight,
          lineHeight: typography.bodyShort.lineHeight,
          height: '56px'
        },
        placeholder: {
          fontFamily: typography.bodyShort.fontFamily,
          fontSize: typography.bodyShort.fontSize,
          fontWeight: typography.bodyShort.fontWeight,
          lineHeight: typography.bodyShort.lineHeight
        }
      },
      header: {
        height: header.height,
        searchPanel: {
          inputHeight: '32px',
          inputLeftMaring: 0,
          selectedCharFontWeight: 700
        },
        nav: {
          iconPadding: '0 6px'
        }
      },
      menu: {
        expandedWidth: menu.expanded,
        collapsedWidth: menu.collapsed,
        border: 0,
        header: {
          height: header.height
        },
        itemContainer: {
          padding: '0',
          paddingLeft: '16px',
          collapsedPadding: '0',
          height: '48px',
          badgeHeight: '40px',
          width: menu.expanded,
          marginBottom: '0'
        },
        itemTitle: {
          fontSize: '14px',
          fontWeight: '300',
          fontWeightBold: '300',
          letterSpacing: '0',
          lineHeight: '16px',
          color: '#000',
          opacity: '0.60',
          hover: {
            opacity: 1
          }
        },
        itemIcon: {
          width: menu.collapsed,
          opacity: '0.65',
          lineHeight: '32px',
          margin: '0'
        },
        itemArrowContainer: {
          width: '48px',
          height: '48px',
          border: '1px solid #aabfd84d'
        },
        itemArrow: {
          width: '16px',
          height: '16px'
        },
        submenu: {
          width: menu.expanded,
          sectionPadding: '15px 16px',
          dividerHeight: '1px',
          sectionFontSize: '11px',
          sectionFontWeight: '300',
          sectionLetterSpacing: '1px',
          sectionLineHeight: '16px',
          sectionTextTransform: 'uppercase',
          sectionTitleOpacity: '0.65'
        },
        footer: {
          horizontalPadding: '8px'
        }
      },
      breadcrumbs: {
        fontSize: typography.bodyHeader.fontSize,
        fontFamily: typography.bodyHeader.fontFamily,
        fontWeight: typography.bodyHeader.fontWeight,
        lineHeight: typography.bodyHeader.lineHeight,
        popover: {
          shadow: '0',
          padding: '5px 0',
          itemPadding: '8px 5px',
          itemFontFamily: typography.bodyHeader.fontFamily,
          itemFontSize: '12px',
          itemFontWeight: '500',
          itemLineHeight: '1'
        }
      },
      snack: {
        fontSize: '12px',
        fontWeight: 500,
        containerWidth: '352px',
        closeBtnHeight: '24px',
        closeBtnWidth: '24px',
        readBtnHeight: '24px',
        readBtnWidth: '24px',
        topPadding: spacing.s2,
        body: {
          fontSize: typography.button.fontSize,
          fontWeight: typography.button.fontWeight,
          lineHeight: typography.button.lineHeight,
          padding: `${spacing.s3}`,
          contentMargin: `0 ${spacing.s4}`
        },
        timestamp: {
          fontSize: '10px',
          fontWeight: 300,
          lineHeight: 'normal'
        },
        button: {
          fontSize: '10px',
          fontWeight: 500,
          lineHeight: '16px',
          height: 'auto',
          btnMargin: `0 ${spacing.s3} 0 0`
        },
        placeholder: {
          fontSize: '14px',
          fontWeight: 300
        }
      }
    },
    buttons: {
      fontFamily: typography.button.fontFamily,
      default: {
        fontSize: typography.button.fontSize,
        fontWeight: typography.button.fontWeight,
        height: '48px',
        width: '100%',
        minWidth: '150px',
        minWidthIconOnly: '32px',
        textTransform: typography.button.textTransform,
        textTransformFirstLetter: typography.button.textTransform,
        letterSpacing: typography.button.letterSpacing,
        lineHeight: typography.button.lineHeight,
        padding: '16px'
      },
      inline: {
        fontSize: typography.button.fontSize,
        fontWeight: typography.button.fontWeight,
        height: '32px',
        width: 'auto',
        minWidth: '96px',
        minWidthIconOnly: '32px',
        textTransform: typography.button.textTransform,
        textTransformFirstLetter: typography.button.textTransform,
        letterSpacing: typography.button.letterSpacing,
        lineHeight: typography.button.lineHeight,
        padding: '8px 16px',
        iconPadding: '12px',
        borderRadius: '3px',
        boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.2)',
        margin: '0px',
        dropdownButtonPadding: '4px 8px 4px 16px',
        dropdownButtonIconMargin: '0 0 0 8px',
        splitDropdownDropPadding: '4px'
      },
      link: {
        fontSize: typography.button.fontSize,
        fontWeight: typography.button.fontWeight,
        textTransform: typography.button.textTransform,
        letterSpacing: typography.button.letterSpacing
      }
    },
    buttonGroup: {
      groupMarginFramed: '1px',
      groupMarginInline: '8px',
      groupPadding: '0',
      contextMenu: {
        trigger: {
          width: '48px',
          margin: 0,
          borderWidth: 0,
          borderStyle: 'solid'
        },
        popup: {
          padding: 0
        },
        item: {
          fontFamily: typography.button.fontFamily,
          fontSize: typography.button.fontSize,
          fontWeight: typography.button.fontWeight,
          lineHeight: '18px',
          letterSpacing: typography.button.letterSpacing,
          height: '48px',
          textTransform: 'uppercase',
          borderWidth: '0 0 1px 0',
          borderStyle: 'solid'
        }
      }
    },
    card: {
      borderRadius: '8px',
      title: {
        fontSize: '36px',
        fontWeight: 500,
        lineHeight: '40px'
      },
      description: {
        fontWeight: '300'
      }
    },
    modals: {
      padding: '0',
      headerHeight: '48px',
      headerPadding: `0 ${spacing.s3}`,
      headerTitlePosition: 'left',
      confirmAlignment: 'center',
      borderRadius: '0px',
      title: {
        fontFamily: typography.bodyHeader.fontFamily,
        fontSize: typography.bodyHeader.fontSize,
        fontWeight: typography.bodyHeader.fontWeight,
        lineHeight: typography.bodyHeader.lineHeight,
        textTransform: 'capitalize',
        padding: '0 0 0 4px',
        actionsTop: '8px',
        actionsRight: '12px'
      },
      content: {
        padding: spacing.s4,
        fontFamily: typography.bodyLong.fontFamily,
        fontSize: typography.bodyLong.fontSize,
        fontWeight: typography.bodyLong.fontWeight,
        lineHeight: typography.bodyLong.lineHeight
      }
    },
    accordion: {
      badge: {
        fontFamily: typography.tooltipLabel.fontFamily,
        fontSize: typography.tooltipLabel.fontSize,
        fontWeight: typography.tooltipLabel.fontWeight,
        lineHeight: '17px',
        letterSpacing: typography.tooltipLabel.letterSpacing,
        height: '17px',
        borderRadius: '14px',
        padding: '0 7px',
        right: '46px'
      },
      arrowIcon: {
        height: '13px',
        width: '13px'
      },
      header: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing,
        textTransform: typography.bodyShort.textTransform,
        borderTopWidth: '0px',
        borderBottomWidth: '1px',
        borderBottomWidthActive: '1px',
        height: '48px',
        padding: '0px 16px'
      }
    },
    panel: {
      fontSize: '12px',
      fontFamily: '"Museo Sans", "Verdana", sans-serif',
      fontWeight: 400,
      lineHeight: '40px',
      letterSpacing: 0,
      textTransform: 'capitalize'
    },
    numberField: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      letterSpacing: typography.bodyShort.letterSpacing,
      height: '28px',
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing,
        marginBottom: '10px'
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: '300',
        lineHeight: '14px'
      }
    },
    numericInput: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      letterSpacing: typography.bodyShort.letterSpacing,
      height: '28px',
      padding: `0 ${spacing.s2}`,
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing,
        marginBottom: '10px'
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: '300',
        lineHeight: '14px'
      }
    },
    radio: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      size: '16px',
      labelShift: spacing.s4,
      bottomMargin: spacing.s4,
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        marginBottom: '10px'
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    switch: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      thumbSize: '12px',
      hoverThumbSize: '14px',
      thumbShift: '2px',
      labelShift: spacing.s3,
      width: '28px',
      height: '16px',
      radius: '8px',
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        marginBottom: '10px'
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    tagsInput: {
      fontSize: '12px',
      fontFamily: '"Museo Sans", "Verdana", sans-serif',
      fontWeight: 300,
      lineHeight: '22px',
      height: '22px',
      letterSpacing: typography.bodyShort.letterSpacing,
      tagBorderRadius: '2px',
      containerPadding: '0 3px',
      containerGap: '5px',
      inputPadding: '0 4px',
      tagHeight: '22px',
      tagInnerPadding: '4px 4px 4px 8px',
      tagInnerGap: '8px',
      placeholder: {
        fontSize: typography.bodyShort.fontSize,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing
      },
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing,
        marginBottom: '10px'
      },
      description: {
        fontSize: typography.bodyShort.fontSize,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    dateDropdown: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: '15px',
      letterSpacing: typography.bodyShort.letterSpacing,
      height: '28px',
      padding: `6px ${spacing.s2}`,
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing,
        marginBottom: '10px'
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      }
    },
    calendar: {
      borderRadius: '2px',
      width: '288px',
      monthControls: {
        height: '40px',
        padding: '8px 0px',
        margin: '0px 8px',
        borderBottomWidth: '1px',
        label: {
          fontSize: typography.bodyHeader.fontSize,
          fontFamily: typography.bodyHeader.fontFamily,
          fontWeight: typography.bodyHeader.fontWeight,
          lineHeight: typography.bodyHeader.lineHeight,
          letterSpacing: typography.bodyHeader.letterSpacing
        }
      },
      weekDays: {
        padding: '12px 4px',
        label: {
          fontSize: typography.bodyHeader.fontSize,
          fontFamily: typography.bodyHeader.fontFamily,
          fontWeight: 500,
          lineHeight: '20px',
          letterSpacing: typography.bodyHeader.letterSpacing
        }
      },
      days: {
        containerPadding: '0px 4px 4px',
        width: '36px',
        height: '36px',
        margin: '2px',
        padding: '10px 2px',
        borderRadius: '4px',
        label: {
          fontSize: typography.bodyShort.fontSize,
          fontFamily: typography.bodyShort.fontFamily,
          fontWeight: typography.bodyShort.fontWeight,
          lineHeight: typography.bodyShort.lineHeight,
          letterSpacing: typography.bodyShort.letterSpacing
        }
      },
      year: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: '32px',
        letterSpacing: typography.bodyShort.letterSpacing
      },
      time: {
        inputsPadding: '0 6px',
        buttonPadding: '8px 6px'
      }
    },
    datePicker: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      caption: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight
      },
      weekdays: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: 500
      }
    },
    textField: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      borderWidth: '1px',
      height: '28px',
      inputPadding: `6px ${spacing.s2}`,
      areaPadding: '7px 10px',
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        marginBottom: '10px'
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      passwordIcon: {
        height: '24px',
        width: '24px'
      }
    },
    toast: {
      fontSize: typography.bodyHeader.fontSize,
      fontFamily: typography.bodyHeader.fontFamily,
      fontWeight: typography.bodyHeader.fontWeight,
      lineHeight: typography.bodyHeader.lineHeight,
      letterSpacing: typography.bodyHeader.letterSpacing,
      iconHeight: '32px',
      iconWidth: '32px',
      iconMargin: `0 ${spacing.s4}`,
      toastContainerHeight: '48px',
      buttonBorder: 'none',
      buttonBorderHover: 'none',
      buttonBorderActive: 'none',
      btnContainerHeight: '100%',
      btnContainerMargin: '0',
      btnActionMargin: '0 1px 0 0'
    },
    tooltip: {
      fontFamily: typography.tooltipLabel.fontFamily,
      fontSize: typography.tooltipLabel.fontSize,
      fontWeight: typography.tooltipLabel.fontWeight,
      lineHeight: typography.tooltipLabel.lineHeight,
      letterSpacing: 'initial',
      padding: '6px 8px',
      borderRadius: '2px'
    },
    checkbox: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      size: '16px',
      bottomMargin: spacing.s1,
      labelShift: spacing.s4,
      borderRadius: '1px',
      label: {
        fontFamily: typography.bodyShort.fontFamily,
        fontSize: typography.bodyShort.fontSize,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        marginBottom: '10px'
      },
      error: {
        fontFamily: typography.bodyShort.fontFamily,
        fontSize: '12px',
        fontWeight: '300',
        lineHeight: '14px'
      }
    },
    contextMenu: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      letterSpacing: typography.bodyShort.letterSpacing,
      width: '200px',
      itemHeight: '32px',
      containerPadding: '4px 0',
      menuItemPadding: '0 15px',
      menuItemMargin: '0',
      menuItemBorderRadius: '2px',
      borderRadius: '2px',
      dividerMargin: '4px 0px',
      submenuTop: '-4px',
      submenuArrowIcon: {
        height: '16px',
        width: '16px',
        arrowMargin: '0 0 0 15px'
      },
      toggler: {
        display: 'inline-block',
        width: 'auto',
        height: 'auto',
        flexDirection: 'initial',
        alignItems: 'initial',
        justifyContent: 'initial'
      }
    },
    dropdown: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      marginLeft: '24px',
      lineHeight: '15px',
      height: '28px',
      padding: `0 ${spacing.s2}`,
      borderWidth: '0 0 1px 0',
      label: {
        fontFamily: typography.bodyShort.fontFamily,
        fontSize: typography.bodyShort.fontSize,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        marginBottom: '10px'
      },
      description: {
        fontSize: '12px',
        fontWeight: 300,
        marginTop: spacing.s1
      },
      error: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: '14px'
      },
      tag: {
        borderRadius: '0',
        fontSize: '14px',
        fontFamily: '"Museo Sans", "Verdana", sans-serif',
        fontWeight: '300',
        height: '20px',
        margin: '3px',
        padding: '0 24px 0 10px'
      },
      options: {
        padding: `${spacing.s1} 0`,
        shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
        itemHeight: '32px',
        itemPadding: `0 ${spacing.s2}`,
        selectedFontWeight: '300',
        borderRadius: '0px',
        selectedIcon: {
          height: '16px',
          width: '16px'
        }
      }
    },
    filterLayout: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      headerPadding: '0 20px',
      bodyPadding: 0,
      boxShadow: '0px 7px 20px rgba(0, 0, 0, 0.08), 0px 1px 4px rgba(0, 0, 0, 0.05)',
      applyPadding: 0,
      borderRadius: '0px',
      containerWidth: '280px'
    },
    inlineDropdown: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      selectedFontWeight: '300',
      boxShadow: '0px 7px 20px rgba(0, 0, 0, 0.08), 0px 1px 4px rgba(0, 0, 0, 0.05)',
      itemHeight: '30px',
      itemPadding: '0 15px',
      width: '165px'
    },
    tabs: {
      label: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: typography.bodyShort.lineHeight,
        letterSpacing: typography.bodyShort.letterSpacing,
        primaryHeight: '50px',
        primaryFontWeight: 500,
        secondaryHeight: '48px',
        primaryPadding: '17px 12px',
        secondaryPadding: '16px 0'
      },
      navigation: {
        primaryPosition: 'flex-start',
        secondaryPosition: 'center',
        primaryPaddingTop: '8px'
      },
      badge: {
        lineHeight: '17px',
        fontWeight: 300,
        borderRadius: '14px',
        height: '17px'
      },
      spacingBetweenTabs: '17px'
    },
    verticalTabs: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: '40px',
      letterSpacing: typography.bodyShort.letterSpacing
    },
    pagination: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      letterSpacing: typography.bodyShort.letterSpacing,
      currentPage: {
        width: '30px',
        height: '30px',
        border: 'none'
      },
      topPagination: {
        dropdownMinWidth: '54px'
      },
      bottomPagination: {
        fontSize: typography.bodyShort.fontSize,
        fontFamily: typography.bodyShort.fontFamily,
        fontWeight: typography.bodyShort.fontWeight,
        lineHeight: '17px',
        letterSpacing: typography.bodyShort.letterSpacing,
        itemPadding: '0 8px',
        itemMargin: '0 6px',
        padding: '16px 0'
      },
      action: {
        height: 20,
        width: 11
      }
    },
    table: {
      header: {
        fontFamily: '"Museo Sans", "Verdana", sans-serif',
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 'normal',
        letterSpacing: typography.bodyShort.letterSpacing
      },
      column: {
        fontFamily: '"Museo Sans", "Verdana", sans-serif',
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 'normal',
        padding: '0 16px',
        letterSpacing: typography.bodyShort.letterSpacing
      },
      row: {
        height: '40px'
      }
    },
    label: {
      fontSize: typography.bodyShort.fontSize,
      fontFamily: typography.bodyShort.fontFamily,
      fontWeight: typography.bodyShort.fontWeight,
      lineHeight: typography.bodyShort.lineHeight,
      letterSpacing: typography.bodyShort.letterSpacing
    },
    stepper: {
      height: '48px',
      fontFamily: typography.bodyShort.fontFamily,
      fontSize: typography.bodyShort.fontSize,
      lineHeight: typography.bodyShort.lineHeight,
      fontWeight: typography.bodyShort.fontWeight,
      chevronIconWidth: '24px',
      chevronIconHeight: '24px',
      border: '1px solid transparent',
      borderHover: `1px solid ${colors.primary.primary75}`,
      borderSelected: `3px solid ${colors.primary.primary75}`,
      itemPadding: '8px 0px 16px 0px',
      itemPaddingSelected: '8px 0px 14px 0px',
      successIconHeight: '16px',
      successIconWidth: '16px',
      stepIndicator: {
        width: '16px',
        height: '16px',
        borderRadius: '4px',
        fontFamily: typography.bodyShort.fontFamily,
        fontSize: typography.bodyShort.fontSize,
        lineHeight: typography.bodyShort.lineHeight,
        fontWeight: 500
      }
    },
    badge: {
      badgeHeight: '16px',
      badgeWidth: '16px',
      badgeHeightDot: '8px',
      badgeWidthDot: '8px',
      fontSize: typography.sectionHeader.fontSize,
      fontWeight: typography.sectionHeader.fontWeight,
      lineHeight: typography.sectionHeader.lineHeight,
      fontFamily: typography.sectionHeader.fontFamily
    },
    textTag: {
      height: '24px',
      minWidth: '16px',
      borderRadius: '8px',
      padding: '4px 12px',
      fontSize: typography.button.fontSize,
      fontWeight: typography.button.fontWeight,
      lineHeight: typography.button.lineHeight,
      fontFamily: typography.button.fontFamily
    },
    progressBar: {
      fontFamily: typography.bodyShort.fontFamily,
      fontSize: typography.bodyShort.fontSize,
      lineHeight: typography.bodyShort.lineHeight,
      fontWeight: typography.bodyShort.fontWeight
    },
    slider: {
      fontFamily: typography.bodyShort.fontFamily,
      fontSize: typography.bodyShort.fontSize,
      lineHeight: typography.bodyShort.lineHeight,
      fontWeight: typography.bodyShort.fontWeight
    },
    contentSwitcher: {
      borderRadius: '3px',
      itemHeight: '24px',
      innerPadding: '4px 16px',
      fontFamily: typography.button.fontFamily,
      fontSize: typography.button.fontSize,
      lineHeight: typography.button.lineHeight,
      fontWeight: typography.button.fontWeight,
      letterSpacing: typography.button.letterSpacing
    },
    chip: {
      padding: '5px 12px',
      borderRadius: '12px',
      fontSize: typography.bodyLong.fontSize,
      fontWeight: typography.bodyLong.fontWeight,
      letterSpacing: typography.bodyLong.letterSpacing,
      lineHeight: typography.bodyLong.lineHeight,
      fontFamily: typography.bodyLong.fontFamily
    },
    iconButton: {
      padding: '0px',
      borderRadius: '5px',
      iconWidth: '32px',
      iconHeight: '32px',
      tabIconOffset: '-5px'
    },
    colors: {
      palette: colors,
      common: {
        outlineColor: 'transparent',
        outlineLinkColor: '#000',
        disabledColor: '#bdbdbd'
      },
      appFrame: {
        shimmer: {
          placeholder: {
            header: {
              bg: colors.primary.primary75,
              tint: colors.primary.primary50
            },
            menu: {
              bg: '#435262',
              tint: '#5d6874'
            }
          }
        },
        bellWidget: {
          headerBg: colors.neutral.white100,
          headerBorderColor: colors.neutral.neutral10,
          headerTextColor: colors.neutral.neutral45,
          contentBg: colors.neutral.white100,
          itemDate: 'rgba(53, 65, 74, 0.5)',
          itemBorder: colors.neutral.neutral10,
          itemHoverBg: '#f2f6fa',
          itemUnreadBg: '#f6fafc',
          loaderColor: '#222',
          footerTextColor: colors.neutral.neutral45,
          placeholderColor: colors.neutral.neutral45
        },
        header: {
          bg: colors.primary.primary100,
          borderColor: colors.primary.primary100,
          menuToggler: colors.neutral.white100,
          icon: colors.neutral.white100,
          iconNav: '#9cb8d9',
          iconNavHover: colors.neutral.white100,
          iconNavDisabled: colors.neutral.neutral25,
          badge: colors.neutral.white100,
          placeholder: colors.neutral.white100,
          badgeBg: '#f5a623',
          searchBorder: colors.neutral.white100,
          searchPlaceholder: colors.neutral.white100,
          searchPanelBg: colors.primary.primary100,
          searchPanelText: colors.neutral.white100,
          searchPanelHover: '#2a527f',
          menuTogglerBg: '#0a0a0a',
          logoBorder: '#051c2c',
          switcherHoverBg: '#f0f0f0',
          switcherIconColor: '#000',
          switcherDropdownBg: colors.neutral.white100,
          switcherDropdownItemHoverBg: '#f0f0f0',
          switcherActiveItemBorderColor: '#1f40e6',
          switcherLinkColor: '#000',
          switcherLinkHoverColor: '#1f40e6',
          moduleIconColor: colors.neutral.white100
        },
        menu: {
          toggler: '#adb4bc',
          line: 'rgba(169, 190, 215, 0.3)',
          bg: '#334559',
          headerBg: '#334559',
          borderColor: '#334559',
          headerText: colors.neutral.white100,
          badgeBg: '#7adf67',
          delimiter: 'rgba(255, 255, 255, 0.6)',
          tooltipText: colors.neutral.white100,
          tooltipBg: colors.primary.primary100,
          itemIconColor: colors.neutral.white100,
          itemText: colors.neutral.white100,
          itemTextHover: colors.neutral.white100,
          itemActiveBg: colors.neutral.white100,
          itemActiveBadge: colors.accent.accent100,
          itemHoverBg: colors.primary.primary100,
          itemArrowIndicator: colors.neutral.white100,
          itemArrowAreaBorder: '#aabfd84d',
          groupBg: '#47627a',
          groupHoverBg: '#4c93e6',
          groupSeparator: 'rgba(170, 191, 216, 0.3)',
          placeholderBgColor: '#646d75',
          placeholderTintColor: '#848e96',
          submenuDivider: colors.primary.primary50,
          submenuSectionTitleColor: colors.neutral.white100,
          switcherBg: '#47627a',
          switcherHoverBg: '#4c93e6',
          switcherText: colors.neutral.white100,
          switcherHeaderTextColor: colors.neutral.white100,
          switcherLine: 'rgba(170, 191, 216, 0.3)',
          switcherShadow: 'rgba(0, 0, 0, 0.15)',
          switcherTogglerColor: colors.neutral.white100
        },
        snack: {
          closeBtn: colors.neutral.neutral25,
          closeBtnHover: '#222',
          readBtn: '#b2b2b2',
          readBtnHover: '#222',
          text: colors.neutral.neutral60,
          background: colors.neutral.white100,
          link: colors.primary.primary75,
          linkHover: colors.primary.primary100,
          categories: {
            critical: colors.status.error100,
            error: colors.status.error100,
            warning: colors.status.alert100,
            success: colors.status.success100,
            info: colors.primary.primary100,
            default: colors.neutral.neutral25
          }
        },
        breadcrumbs: {
          containerBg: 'transparent',
          color: colors.neutral.white100,
          linkColor: colors.neutral.white100,
          hoverColor: colors.neutral.white100,
          separator: colors.neutral.white100,
          popoverBg: colors.variant.primary,
          popoverItemColor: colors.neutral.white100,
          popoverItemLinkColor: colors.neutral.white100,
          popoverItemBorder: '#a9bed74d',
          popoverItemHover: colors.primary.primary100,
          popoverItemTextHover: colors.neutral.white100
        }
      },
      button: {
        textColor: colors.neutral.white100,
        disabledBgColor: colors.neutral.neutral20,
        primary: {
          textColor: colors.neutral.white100,
          linkColor: colors.accent.accent100,
          linkHoverColor: colors.accent.accent100,
          bgColor: colors.accent.accent100,
          hoverBgColor: '#f29130',
          activeBgColor: '#f07b22',
          disabledTextColor: colors.neutral.neutral60,
          disabledBgColor: colors.neutral.neutral10,
          disabledBorder: `1px solid ${colors.neutral.neutral10}`,
          linkArrowColor: colors.accent.accent100,
          dark: {
            textColor: colors.neutral.white100,
            linkColor: colors.accent.accent100,
            linkHoverColor: colors.accent.accent100,
            bgColor: colors.accent.accent100,
            hoverBgColor: '#f29130',
            activeBgColor: '#f07b22',
            disabledTextColor: colors.neutral.neutral60,
            disabledBgColor: colors.neutral.neutral10,
            disabledBorder: `1px solid ${colors.neutral.neutral10}`,
            linkArrowColor: colors.accent.accent100
          }
        },
        secondary: {
          textColor: colors.neutral.white100,
          linkColor: colors.primary.primary50,
          linkHoverColor: colors.primary.primary50,
          bgColor: colors.primary.primary50,
          hoverBgColor: '#8bacd2',
          activeBgColor: '#749ac8',
          disabledTextColor: colors.neutral.neutral60,
          disabledBgColor: colors.neutral.neutral10,
          disabledBorder: `1px solid ${colors.neutral.neutral10}`,
          linkArrowColor: colors.primary.primary50,
          dark: {
            textColor: colors.neutral.white100,
            linkColor: colors.primary.primary50,
            linkHoverColor: colors.primary.primary50,
            bgColor: colors.primary.primary50,
            hoverBgColor: '#8bacd2',
            activeBgColor: '#749ac8',
            disabledTextColor: colors.neutral.neutral60,
            disabledBgColor: colors.neutral.neutral10,
            disabledBorder: `1px solid ${colors.neutral.neutral10}`,
            linkArrowColor: colors.primary.primary50
          }
        },
        tertiary: {
          textColor: colors.primary.primary75,
          linkColor: colors.primary.primary75,
          linkHoverColor: colors.primary.primary75,
          bgColor: 'transparent',
          hoverBgColor: colors.primary.primary10,
          activeBgColor: colors.primary.primary15,
          border: `1px solid ${colors.primary.primary75}`,
          disabledTextColor: colors.neutral.neutral60,
          disabledBgColor: 'transparent',
          disabledBorder: `1px solid ${colors.neutral.neutral40}`,
          subBorderColor: colors.primary.primary50,
          linkArrowColor: colors.primary.primary75,
          dark: {
            textColor: colors.primary.primary75,
            linkColor: colors.primary.primary75,
            linkHoverColor: colors.primary.primary75,
            bgColor: 'transparent',
            hoverBgColor: colors.primary.primary10,
            activeBgColor: colors.primary.primary15,
            border: `1px solid ${colors.primary.primary75}`,
            disabledTextColor: colors.neutral.neutral60,
            disabledBgColor: 'transparent',
            disabledBorder: `1px solid ${colors.neutral.neutral40}`,
            subBorderColor: colors.primary.primary50,
            linkArrowColor: colors.primary.primary75
          }
        },
        ghost: {
          textColor: colors.primary.primary75,
          linkColor: colors.primary.primary75,
          linkHoverColor: colors.primary.primary75,
          bgColor: 'transparent',
          hoverBgColor: colors.primary.primary10,
          activeBgColor: colors.primary.primary15,
          border: '1px solid transparent',
          disabledTextColor: colors.neutral.neutral60,
          disabledBgColor: 'transparent',
          disabledBorder: '1px solid transparent',
          subBorderColor: colors.primary.primary50,
          linkArrowColor: colors.primary.primary75,
          dark: {
            textColor: colors.primary.primary75,
            linkColor: colors.primary.primary75,
            linkHoverColor: colors.primary.primary75,
            bgColor: 'transparent',
            hoverBgColor: colors.primary.primary10,
            activeBgColor: colors.primary.primary15,
            border: '1px solid transparent',
            disabledTextColor: colors.neutral.neutral60,
            disabledBgColor: 'transparent',
            disabledBorder: '1px solid transparent',
            subBorderColor: colors.primary.primary50,
            linkArrowColor: colors.primary.primary75
          }
        },
        danger: {
          textColor: colors.neutral.white100,
          linkColor: colors.status.error100,
          linkHoverColor: colors.status.error100,
          bgColor: colors.status.error100,
          hoverBgColor: '#c50015',
          activeBgColor: '#b9000f',
          disabledTextColor: colors.neutral.neutral60,
          disabledBgColor: colors.neutral.neutral10,
          disabledBorder: `1px solid ${colors.neutral.neutral10}`,
          linkArrowColor: colors.status.error100,
          dark: {
            textColor: colors.neutral.white100,
            linkColor: colors.status.error100,
            linkHoverColor: colors.status.error100,
            bgColor: colors.status.error100,
            hoverBgColor: '#c50015',
            activeBgColor: '#b9000f',
            disabledTextColor: colors.neutral.neutral60,
            disabledBgColor: colors.neutral.neutral10,
            disabledBorder: `1px solid ${colors.neutral.neutral10}`,
            linkArrowColor: colors.status.error100
          }
        }
      },
      buttonGroup: {
        contextMenu: {
          shadow: 'none',
          textColor: colors.neutral.white100,
          trigger: {
            bg: colors.primary.primary50,
            hoverBg: colors.primary.primary75,
            borderColor: colors.neutral.white100,
            icon: colors.neutral.white100
          },
          item: {
            text: colors.neutral.white100,
            bg: colors.primary.primary50,
            hoverBg: colors.primary.primary75,
            border: colors.neutral.white100
          }
        }
      },
      typography: {
        text: colors.neutral.neutral80
      },
      card: {
        containerBg: colors.neutral.white100,
        titleColor: colors.neutral.neutral60,
        descriptionColor: colors.neutral.neutral40,
        iconColor: colors.primary.primary100
      },
      splash: {
        background: colors.primary.primary100
      },
      verticalTabs: {
        text: colors.primary.primary100,
        textInactive: colors.neutral.neutral45,
        headerText: colors.neutral.neutral45,
        headerShadow: colors.neutral.neutral10,
        hoverBg: colors.primary.primary10,
        hoverText: colors.primary.primary100,
        activeBg: 'transparent',
        activeBorder: colors.primary.primary100
      },
      accordion: {
        headerBg: colors.primary.primary10,
        headerActiveBg: colors.primary.primary100,
        headerHoverBg: colors.primary.primary100,
        borderColor: colors.neutral.neutral10,
        iconColor: colors.primary.primary100,
        iconActiveColor: colors.neutral.white100,
        iconHoverColor: colors.neutral.white100,
        labelColor: colors.primary.primary100,
        labelHoverColor: colors.neutral.white100,
        labelActiveColor: colors.neutral.white100
      },
      panel: {
        headerBg: colors.primary.primary100,
        headerText: colors.neutral.white100,
        connectorBg: '#f0f4f7',
        icon: '#9db9d9',
        border: colors.neutral.neutral10,
        bodyShadow: '0px 2px 16px 0px rgba(0, 0, 0, 0.05)'
      },
      tabs: {
        text: colors.neutral.neutral40,
        primaryBg: colors.primary.primary10,
        primaryHoveredBg: colors.neutral.white100,
        primaryHoveredText: colors.primary.primary75,
        primaryHoveredShadow: 'rgba(0, 0, 0, 0.08)',
        primaryTabBg: colors.neutral.white100,
        primaryActiveBg: colors.neutral.white100,
        primaryActiveText: colors.primary.primary100,
        primaryActiveShadow: 'rgba(0, 0, 0, 0.16)',
        secondaryBg: colors.neutral.white100,
        secondaryActiveText: colors.primary.primary100,
        secondaryShadow: colors.neutral.neutral10,
        badgeBg: colors.status.error75,
        badgeText: colors.neutral.white100
      },
      loadingIndicator: {
        overlayBg: 'rgba(255, 255, 255, 0.9)',
        externalBg: 'rgba(255, 255, 255, 0.1)',
        bg: colors.primary.primary100,
        circleBg: colors.primary.primary100,
        startColor: '#4679b4',
        stopColor: '#a7cffa'
      },
      unsupportedBrowser: {
        bg: colors.primary.primary100
      },
      forbidden: {
        bg: 'inherit',
        mainTextColor: '#000',
        secondaryTextColor: '#4d4d4d'
      },
      pageNotFound: {
        bg: 'inherit'
      },
      toast: {
        errorButtonText: colors.neutral.white100,
        errorText: colors.neutral.white100,
        errorBg: colors.status.error100,
        actionsErrorBg: colors.variant.error,
        dangerButtonText: colors.neutral.white100,
        dangerText: colors.neutral.white100,
        dangerBg: colors.status.error100,
        actionsDangerBg: colors.variant.error,
        warnButtonText: colors.neutral.white100,
        warnText: colors.neutral.white100,
        warnBg: colors.accent.accent100,
        actionsWarnBg: colors.variant.accent,
        infoButtonText: colors.neutral.white100,
        infoText: colors.neutral.white100,
        infoBg: colors.primary.primary50,
        actionsInfoBg: colors.variant.primary,
        successButtonText: colors.neutral.white100,
        successText: colors.neutral.white100,
        successBg: colors.status.success100,
        actionsSuccessBg: colors.variant.success,
        neutralButtonText: colors.neutral.white100,
        neutralText: colors.neutral.white100,
        neutralBg: colors.neutral.neutral60,
        actionsNeutralBg: colors.neutral.neutral80,
        warnIcon: colors.neutral.white100,
        errorIcon: colors.neutral.white100,
        infoIcon: colors.neutral.white100,
        dangerIcon: colors.neutral.white100,
        successIcon: colors.neutral.white100,
        neutralIcon: colors.neutral.white100
      },
      table: {
        text: colors.neutral.neutral80,
        selection: '#6fc664',
        rowBorder: colors.neutral.neutral10,
        columnBorder: colors.neutral.neutral10,
        selectedBg: '#f3f6fa'
      },
      contextMenu: {
        itemText: colors.neutral.white100,
        divider: colors.primary.primary75,
        hoverBg: '#326299',
        icon: '#326299',
        bg: colors.primary.primary100,
        arrowIndicatorColor: colors.neutral.white100,
        togglerBg: 'transparent',
        customIconsColor: colors.neutral.white100,
        boxShadow: '0 3px 6px 0 rgba(0, 0, 0, .2)',
        itemTextDisabled: colors.neutral.neutral20,
        iconDisabled: colors.neutral.neutral20
      },
      splitter: {
        icon: colors.primary.primary100,
        bg: colors.neutral.neutral10,
        hoverBg: colors.neutral.neutral15,
        activeBg: colors.neutral.neutral15,
        indicatorBg: colors.neutral.white100,
        indicatorBorder: colors.neutral.neutral15
      },
      contentPlaceholder: {
        bgColor: '#eee',
        gradientTint: '#f5f5f5'
      },
      filterLayout: {
        label: colors.primary.primary100,
        badgeBg: '#f5a623',
        bg: colors.primary.primary100,
        border: colors.primary.primary75,
        text: colors.neutral.white100,
        checkboxText: colors.neutral.white100,
        radioText: colors.neutral.white100
      },
      tooltip: {
        shadow: '0 1px 3px 0 rgba(0, 0, 0, 0.15)',
        default: colors.neutral.neutral60,
        defaultText: colors.neutral.white100,
        error: colors.variant.error,
        errorText: colors.neutral.white100,
        warning: colors.variant.accent,
        warningText: colors.neutral.white100,
        info: colors.variant.success,
        infoText: colors.neutral.white100
      },
      label: {
        text: colors.neutral.white100,
        shadow: 'rgba(34, 34, 34, 0.2)',
        bg: colors.neutral.neutral60
      },
      modal: {
        bg: colors.neutral.white100,
        icon: colors.neutral.white100,
        iconHover: colors.neutral.neutral10,
        shadow: '0 4px 6px 0 rgba(0, 0, 0, 0.15)',
        headerText: colors.neutral.white100,
        headerBg: colors.primary.primary100,
        headerBorder: colors.primary.primary100
      },
      inlineDropdown: {
        inputBg: colors.neutral.white100,
        text: colors.neutral.neutral80,
        label: colors.neutral.neutral45,
        bg: colors.primary.primary10,
        disableText: colors.neutral.neutral40,
        hoverBg: colors.primary.primary20,
        hoverTextColor: colors.neutral.neutral80,
        icon: colors.neutral.neutral80
      },
      checkbox: {
        light: {
          textColor: colors.neutral.neutral45,
          borderColor: colors.primary.primary25,
          bgColor: colors.primary.primary10,
          hoverBgColor: colors.neutral.white100,
          hoverBorderColor: colors.primary.primary100,
          checkedBgColor: colors.primary.primary10,
          checkedBorderColor: colors.primary.primary25,
          checkedHoverBgColor: colors.neutral.white100,
          checkedHoverBorderColor: colors.primary.primary100,
          checkBorderColor: colors.primary.primary100,
          disabledBorderColor: colors.neutral.neutral15,
          disabledBgColor: colors.neutral.neutral5,
          disabledCheckBorderColor: colors.neutral.neutral25,
          disabledTextColor: colors.neutral.neutral40,
          disabledCheckedBorderColor: colors.neutral.neutral15,
          disabledCheckedBgColor: colors.neutral.neutral5,
          asteriskColor: colors.status.error100,
          asteriskDisabledColor: colors.status.error75,
          errorMessageColor: colors.status.error100,
          groupLabelColor: colors.neutral.neutral45,
          errorTextColor: colors.neutral.neutral45,
          errorBgColor: colors.primary.primary10,
          errorBorderColor: colors.primary.primary25,
          disabledCheckedErrorBgColor: colors.neutral.neutral5,
          disabledCheckedErrorBorderColor: colors.neutral.neutral15,
          checkedErrorBgColor: colors.primary.primary10,
          checkedErrorBorderColor: colors.primary.primary25
        },
        medium: {
          textColor: colors.neutral.neutral45,
          borderColor: colors.primary.primary20,
          bgColor: colors.neutral.white100,
          hoverBgColor: colors.neutral.white100,
          hoverBorderColor: colors.primary.primary100,
          checkedBgColor: colors.neutral.white100,
          checkedBorderColor: colors.primary.primary25,
          checkedHoverBgColor: colors.neutral.white100,
          checkedHoverBorderColor: colors.primary.primary100,
          checkBorderColor: colors.primary.primary100,
          disabledBorderColor: colors.neutral.neutral15,
          disabledBgColor: colors.neutral.neutral5,
          disabledCheckBorderColor: colors.neutral.neutral25,
          disabledTextColor: colors.neutral.neutral40,
          disabledCheckedBorderColor: colors.neutral.neutral15,
          disabledCheckedBgColor: colors.neutral.neutral5,
          asteriskColor: colors.status.error100,
          asteriskDisabledColor: colors.status.error75,
          errorMessageColor: colors.status.error100,
          groupLabelColor: colors.neutral.neutral45,
          errorTextColor: colors.neutral.neutral45,
          errorBgColor: colors.neutral.white100,
          errorBorderColor: colors.primary.primary20,
          disabledCheckedErrorBgColor: colors.neutral.neutral5,
          disabledCheckedErrorBorderColor: colors.neutral.neutral15,
          checkedErrorBgColor: colors.neutral.white100,
          checkedErrorBorderColor: colors.primary.primary25
        },
        dark: {
          textColor: colors.neutral.white100,
          borderColor: '#326299',
          bgColor: '#326299',
          hoverBgColor: colors.variant.primary,
          hoverBorderColor: colors.variant.primary,
          checkedBgColor: colors.primary.primary10,
          checkedBorderColor: colors.primary.primary10,
          checkedHoverBgColor: colors.neutral.white100,
          checkedHoverBorderColor: colors.neutral.white100,
          checkBorderColor: colors.primary.primary100,
          disabledBorderColor: '#366ba6',
          disabledBgColor: '#366ba6',
          disabledCheckBorderColor: colors.primary.primary50,
          disabledTextColor: colors.neutral.white100,
          disabledCheckedBorderColor: colors.primary.primary75,
          disabledCheckedBgColor: colors.primary.primary75,
          asteriskColor: colors.status.error100,
          asteriskDisabledColor: colors.status.error75,
          errorMessageColor: colors.status.error100,
          groupLabelColor: colors.neutral.white100,
          errorTextColor: colors.neutral.white100,
          errorBgColor: '#326299',
          errorBorderColor: '#326299',
          disabledCheckedErrorBgColor: colors.primary.primary75,
          disabledCheckedErrorBorderColor: colors.primary.primary75,
          checkedErrorBgColor: colors.primary.primary10,
          checkedErrorBorderColor: colors.primary.primary10
        }
      },
      tagsInput: {
        tagLabel: colors.neutral.white100,
        disabledTagLabel: '#222',
        description: colors.neutral.neutral45,
        tagBg: colors.primary.primary100,
        tagHoverBg: colors.primary.primary75,
        tagRemoveButtonBg: colors.primary.primary100,
        tagRemoveButtonHoverBg: colors.primary.primary75,
        tagRemoveButtonColor: colors.neutral.white100,
        tagRemoveButtonHoverColor: colors.neutral.white100,
        tagInvalidStateBg: colors.status.error100,
        tagInvalidStateHoverBg: colors.status.error75,
        tagInvalidStateRemoveButtonBg: colors.status.error100,
        tagInvalidStateRemoveButtonHoverBg: colors.status.error75,
        tagInvalidStateLabelColor: colors.neutral.white100,
        tagInvalidStateRemoveButtonColor: colors.neutral.white100,
        bg: colors.primary.primary10,
        bgHover: colors.primary.primary15,
        border: colors.primary.primary25,
        borderHover: colors.primary.primary50,
        disabledBorder: colors.neutral.neutral25,
        focusBg: colors.neutral.white100,
        focusBorder: colors.primary.primary100,
        asteriskColor: colors.status.error100,
        errorMessageColor: colors.status.error100,
        errorStateBg: colors.status.error10,
        errorStateBorder: colors.status.error100,
        focusErrorBorder: colors.status.error100,
        labelColor: colors.neutral.neutral45,
        disabledLabelColor: colors.neutral.neutral40,
        disabledBg: colors.neutral.neutral5,
        disabledTagBg: colors.neutral.neutral25,
        disabledTagRemoveButtonBg: colors.neutral.neutral25,
        disabledTagRemoveButtonColor: colors.neutral.neutral40,
        disabledLabel: colors.neutral.neutral45,
        disabledDescription: colors.neutral.neutral45,
        placeholder: colors.neutral.neutral60,
        placeholderHover: colors.neutral.neutral60,
        placeholderFocus: colors.neutral.neutral60,
        placeholderError: colors.status.error50
      },
      switch: {
        light: {
          bulb: colors.neutral.white100,
          disabledOffBulb: colors.neutral.white100,
          disabledOnBulb: colors.neutral.white100,
          onBg: colors.status.success100,
          offBg: colors.primary.primary50,
          onDisabledBg: colors.status.success50,
          offDisabledBg: colors.neutral.neutral15,
          disabledText: colors.neutral.neutral40,
          text: colors.neutral.neutral45,
          titleColor: colors.neutral.neutral45,
          asteriskColor: colors.status.error100,
          errorMessageColor: colors.status.error100
        },
        medium: {
          bulb: colors.neutral.white100,
          disabledOffBulb: colors.neutral.white100,
          disabledOnBulb: colors.neutral.white100,
          onBg: colors.status.success100,
          offBg: colors.primary.primary50,
          onDisabledBg: colors.status.success50,
          offDisabledBg: colors.neutral.neutral15,
          disabledText: colors.neutral.neutral40,
          text: colors.neutral.neutral45,
          titleColor: colors.neutral.neutral45,
          asteriskColor: colors.status.error100,
          errorMessageColor: colors.status.error100
        },
        dark: {
          bulb: colors.neutral.white100,
          disabledOffBulb: colors.primary.primary50,
          disabledOnBulb: colors.status.success50,
          onBg: colors.status.success100,
          offBg: colors.primary.primary50,
          onDisabledBg: colors.status.success100,
          offDisabledBg: colors.primary.primary75,
          disabledText: colors.neutral.white100,
          text: colors.neutral.white100,
          titleColor: colors.neutral.white100,
          asteriskColor: colors.status.error100,
          errorMessageColor: colors.status.error100
        }
      },
      radio: {
        light: {
          bg: colors.primary.primary10,
          borderColor: colors.primary.primary25,
          hoverBg: colors.neutral.white100,
          hoverBorder: colors.primary.primary100,
          checkedBg: colors.neutral.white100,
          text: colors.neutral.neutral45,
          checkedBorder: colors.primary.primary100,
          disabledBg: colors.neutral.neutral5,
          disabledBorder: colors.neutral.neutral15,
          disabledText: colors.neutral.neutral40,
          disabledCheckedBg: colors.neutral.neutral5,
          disabledCheckedBorder: colors.neutral.neutral15,
          disabledCheckedCircleBg: colors.neutral.neutral25,
          groupLabelColor: colors.neutral.neutral45,
          groupErrorMessageColor: colors.status.error100,
          groupAsteriskColor: colors.status.error100
        },
        medium: {
          bg: colors.neutral.white100,
          borderColor: colors.primary.primary25,
          hoverBg: colors.neutral.white100,
          hoverBorder: colors.primary.primary100,
          checkedBg: colors.neutral.white100,
          text: colors.neutral.neutral45,
          checkedBorder: colors.primary.primary100,
          disabledBg: colors.neutral.neutral5,
          disabledBorder: colors.neutral.neutral15,
          disabledText: colors.neutral.neutral40,
          disabledCheckedBg: colors.neutral.neutral5,
          disabledCheckedBorder: colors.neutral.neutral15,
          disabledCheckedCircleBg: colors.neutral.neutral25,
          groupLabelColor: colors.neutral.neutral45,
          groupErrorMessageColor: colors.status.error100,
          groupAsteriskColor: colors.status.error100
        },
        dark: {
          bg: '#326299',
          borderColor: '#326299',
          hoverBg: colors.variant.primary,
          hoverBorder: colors.variant.primary,
          checkedBg: 'transparent',
          text: colors.neutral.white100,
          checkedBorder: colors.neutral.white100,
          disabledBg: '#366ba6',
          disabledBorder: '#366ba6',
          disabledText: colors.neutral.white100,
          disabledCheckedBg: colors.primary.primary75,
          disabledCheckedBorder: colors.primary.primary75,
          disabledCheckedCircleBg: colors.primary.primary50,
          groupLabelColor: colors.neutral.white100,
          groupErrorMessageColor: colors.status.error100,
          groupAsteriskColor: colors.status.error100
        }
      },
      dropdown: {
        light: {
          text: colors.neutral.neutral80,
          focusText: colors.neutral.neutral80,
          label: colors.neutral.neutral45,
          bg: colors.primary.primary10,
          border: colors.primary.primary25,
          focusBg: colors.neutral.white100,
          hoverBg: colors.primary.primary20,
          optionsBg: colors.primary.primary10,
          hoverOptionColor: colors.neutral.neutral80,
          hoverOptionIconColor: colors.primary.primary100,
          focusInput: colors.primary.primary100,
          disableText: colors.neutral.neutral40,
          disableBg: colors.neutral.neutral5,
          disableBorder: colors.neutral.neutral25,
          disabledLabel: colors.neutral.neutral45,
          disabledDescription: colors.neutral.neutral45,
          multiBg: colors.primary.primary25,
          multiHoverBg: colors.primary.primary25,
          multiTextColor: colors.neutral.neutral80,
          multiRemoveIcon: colors.neutral.neutral60,
          multiRemoveIconHover: colors.neutral.white100,
          disableMultiBg: colors.neutral.neutral15,
          selectedIcon: colors.primary.primary100,
          asterisk: colors.status.error100,
          disabledAsterisk: colors.status.error75,
          errorMessageColor: colors.status.error100,
          errorStateBg: colors.status.error10,
          errorBorderColor: colors.status.error100,
          focusErrorBorderColor: colors.status.error100,
          placeholder: colors.neutral.neutral45,
          description: colors.neutral.neutral45,
          iconColor: colors.neutral.neutral60,
          iconFocusColor: colors.primary.primary100,
          iconDisabledColor: colors.neutral.neutral25,
          iconErrorColor: colors.status.error100,
          customOptionIcon: colors.primary.primary100
        },
        medium: {
          text: colors.neutral.neutral80,
          focusText: colors.neutral.neutral80,
          label: colors.neutral.neutral45,
          bg: colors.neutral.white100,
          border: colors.primary.primary25,
          focusBg: colors.neutral.white100,
          hoverBg: colors.primary.primary20,
          optionsBg: colors.primary.primary10,
          hoverOptionColor: colors.neutral.neutral80,
          hoverOptionIconColor: colors.primary.primary100,
          focusInput: colors.primary.primary100,
          disableText: colors.neutral.neutral40,
          disableBg: colors.neutral.neutral5,
          disableBorder: colors.neutral.neutral25,
          disabledLabel: colors.neutral.neutral45,
          disabledDescription: colors.neutral.neutral45,
          multiBg: colors.primary.primary25,
          multiHoverBg: colors.primary.primary25,
          multiTextColor: colors.neutral.neutral80,
          multiRemoveIcon: colors.neutral.neutral60,
          multiRemoveIconHover: colors.neutral.white100,
          disableMultiBg: colors.neutral.neutral15,
          selectedIcon: colors.primary.primary100,
          asterisk: colors.status.error100,
          disabledAsterisk: colors.status.error75,
          errorMessageColor: colors.status.error100,
          errorStateBg: colors.status.error10,
          errorBorderColor: colors.status.error100,
          focusErrorBorderColor: colors.status.error100,
          placeholder: colors.neutral.neutral45,
          description: colors.neutral.neutral45,
          iconColor: colors.neutral.neutral60,
          iconFocusColor: colors.primary.primary100,
          iconDisabledColor: colors.neutral.neutral25,
          iconErrorColor: colors.status.error100,
          customOptionIcon: colors.primary.primary100
        },
        dark: {
          text: colors.neutral.neutral80,
          focusText: colors.neutral.neutral80,
          label: colors.neutral.white100,
          bg: colors.primary.primary10,
          border: colors.primary.primary25,
          focusBg: colors.neutral.white100,
          hoverBg: colors.primary.primary20,
          optionsBg: colors.primary.primary10,
          hoverOptionColor: colors.neutral.neutral80,
          hoverOptionIconColor: colors.primary.primary100,
          focusInput: colors.primary.primary100,
          disableText: colors.neutral.neutral40,
          disableBg: colors.neutral.neutral5,
          disableBorder: colors.neutral.neutral25,
          disabledLabel: colors.neutral.white100,
          disabledDescription: colors.neutral.white100,
          multiBg: colors.primary.primary25,
          multiHoverBg: colors.primary.primary25,
          multiTextColor: colors.neutral.neutral80,
          multiRemoveIcon: colors.neutral.neutral60,
          multiRemoveIconHover: colors.neutral.white100,
          disableMultiBg: colors.neutral.neutral15,
          selectedIcon: colors.primary.primary100,
          asterisk: colors.status.error100,
          disabledAsterisk: colors.status.error75,
          errorMessageColor: colors.status.error100,
          errorStateBg: colors.status.error10,
          errorBorderColor: colors.status.error100,
          focusErrorBorderColor: colors.status.error100,
          placeholder: colors.neutral.neutral45,
          description: colors.neutral.white100,
          iconColor: colors.neutral.neutral60,
          iconFocusColor: colors.primary.primary100,
          iconDisabledColor: colors.neutral.neutral25,
          iconErrorColor: colors.status.error100,
          customOptionIcon: colors.primary.primary100
        }
      },
      textField: {
        light: {
          color: colors.neutral.neutral80,
          label: colors.neutral.neutral45,
          description: colors.neutral.neutral45,
          bg: colors.primary.primary10,
          border: colors.primary.primary25,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary100,
          disabledBorder: colors.neutral.neutral25,
          disabledText: colors.neutral.neutral80,
          disabledBg: colors.neutral.neutral5,
          disabledLabel: colors.neutral.neutral45,
          disabledDescription: colors.neutral.neutral45,
          asterisk: colors.status.error100,
          disabledAsterisk: colors.status.error75,
          checking: colors.primary.primary100,
          validBorder: colors.primary.primary100,
          errorBorder: colors.status.error100,
          focusErrorBorder: colors.status.error100,
          errorBg: colors.status.error10,
          errorColor: colors.status.error100,
          passwordIcon: colors.primary.primary100,
          passwordDisabledIcon: '#c8c8c8',
          placeholder: colors.neutral.neutral45,
          focusPlaceholder: colors.neutral.neutral45,
          iconColor: colors.neutral.neutral60,
          iconFocusColor: colors.primary.primary100,
          iconDisabledColor: colors.neutral.neutral25,
          iconErrorColor: colors.status.error100
        },
        medium: {
          color: colors.neutral.neutral80,
          label: colors.neutral.neutral45,
          description: colors.neutral.neutral45,
          bg: colors.neutral.white100,
          border: colors.primary.primary20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary100,
          disabledBorder: colors.neutral.neutral25,
          disabledText: colors.neutral.neutral80,
          disabledBg: colors.neutral.neutral5,
          disabledLabel: colors.neutral.neutral45,
          disabledDescription: colors.neutral.neutral45,
          asterisk: colors.status.error100,
          disabledAsterisk: colors.status.error75,
          checking: colors.primary.primary100,
          validBorder: colors.primary.primary100,
          errorBorder: colors.status.error100,
          focusErrorBorder: colors.status.error100,
          errorBg: colors.status.error10,
          errorColor: colors.status.error100,
          passwordIcon: colors.primary.primary100,
          passwordDisabledIcon: '#c8c8c8',
          placeholder: colors.neutral.neutral45,
          focusPlaceholder: colors.neutral.neutral45,
          iconColor: colors.neutral.neutral60,
          iconFocusColor: colors.primary.primary100,
          iconDisabledColor: colors.neutral.neutral25,
          iconErrorColor: colors.status.error100
        },
        dark: {
          color: colors.neutral.white100,
          label: colors.neutral.white100,
          description: colors.neutral.white100,
          bg: '#5485bc',
          border: '#5485bc',
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white100,
          focusBorder: colors.neutral.white100,
          disabledBorder: '#366ba6',
          disabledText: colors.neutral.white100,
          disabledBg: '#366ba6',
          disabledLabel: colors.neutral.white100,
          disabledDescription: colors.neutral.white100,
          asterisk: colors.status.error100,
          disabledAsterisk: colors.status.error75,
          checking: colors.primary.primary100,
          validBorder: colors.primary.primary100,
          errorBorder: colors.status.error100,
          focusErrorBorder: colors.status.error100,
          errorBg: colors.status.error10,
          errorColor: colors.status.error100,
          passwordIcon: colors.primary.primary100,
          passwordDisabledIcon: '#c8c8c8',
          placeholder: colors.neutral.white100,
          focusPlaceholder: colors.neutral.neutral80,
          iconColor: colors.neutral.white100,
          iconFocusColor: colors.primary.primary100,
          iconDisabledColor: colors.neutral.neutral25,
          iconErrorColor: colors.status.error100
        }
      },
      numericInput: {
        light: {
          text: colors.neutral.neutral80,
          label: colors.neutral.neutral45,
          description: colors.neutral.neutral45,
          bg: colors.primary.primary10,
          border: colors.primary.primary25,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary100,
          disabledBg: colors.neutral.neutral5,
          disabledText: colors.neutral.neutral40,
          disabledBorder: colors.neutral.neutral25,
          disabledLabel: colors.neutral.neutral45,
          disabledDescription: colors.neutral.neutral45,
          asteriskColor: colors.status.error100,
          errorMessageColor: colors.status.error100,
          errorBg: colors.status.error10,
          errorBorder: colors.status.error100,
          focusErrorBorder: colors.status.error100,
          errorColor: colors.status.error100,
          placeholder: colors.neutral.neutral45
        },
        medium: {
          text: colors.neutral.neutral80,
          label: colors.neutral.neutral45,
          description: colors.neutral.neutral45,
          bg: colors.neutral.white100,
          border: colors.primary.primary20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary100,
          disabledBg: colors.neutral.neutral5,
          disabledText: colors.neutral.neutral80,
          disabledBorder: colors.neutral.neutral25,
          disabledLabel: colors.neutral.neutral45,
          disabledDescription: colors.neutral.neutral45,
          asteriskColor: colors.status.error100,
          errorMessageColor: colors.status.error100,
          errorBg: colors.status.error10,
          errorBorder: colors.status.error100,
          focusErrorBorder: colors.status.error100,
          errorColor: colors.status.error100,
          placeholder: colors.neutral.neutral45
        },
        dark: {
          text: colors.neutral.white100,
          label: colors.neutral.white100,
          description: colors.neutral.white100,
          bg: '#5485bc',
          border: '#5485bc',
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white100,
          focusBorder: colors.neutral.white100,
          disabledBg: '#366ba6',
          disabledText: colors.neutral.white100,
          disabledBorder: '#366ba6',
          disabledLabel: colors.neutral.white100,
          disabledDescription: colors.neutral.white100,
          asteriskColor: colors.status.error100,
          errorMessageColor: colors.status.error100,
          errorBg: colors.status.error10,
          errorColor: colors.status.error100,
          errorBorder: colors.status.error100,
          focusErrorBorder: colors.status.error100,
          placeholder: colors.neutral.white100
        }
      },
      overlay: {
        bg: colors.primary.primary25,
        opacity: '0.6'
      },
      pagination: {
        text: colors.neutral.neutral40,
        currentPageText: colors.primary.primary100,
        activeText: colors.primary.primary100,
        pagerText: colors.neutral.neutral40,
        pagerBg: colors.primary.primary10,
        activeBagde: colors.primary.primary100,
        line: colors.neutral.neutral10,
        label: colors.neutral.neutral60,
        totalPagesLabel: colors.neutral.neutral10,
        action: colors.neutral.neutral40,
        actionHover: colors.primary.primary100,
        actionDisabled: colors.neutral.neutral25
      },
      calendar: {
        bg: colors.primary.primary10,
        textColor: colors.neutral.neutral80,
        textLightGrayColor: colors.primary.primary75,
        border: colors.primary.primary10,
        hoverBg: colors.primary.primary15,
        hoverBorder: colors.primary.primary50,
        activeBg: colors.primary.primary20,
        activeTextColor: colors.neutral.neutral80,
        activeBorder: colors.primary.primary75,
        weekBorder: '#b0bec5',
        monthBg: colors.primary.primary10,
        yearTextColor: colors.neutral.neutral80,
        activeYear: colors.primary.primary100,
        weekTextColor: colors.neutral.neutral60,
        titleColor: colors.neutral.neutral80,
        titleHoverColor: colors.neutral.neutral80,
        titleHoverBg: colors.primary.primary10,
        disabledColor: colors.neutral.neutral60,
        disabledBg: colors.primary.primary10,
        disabledBorder: colors.primary.primary10,
        disabledActiveColor: colors.neutral.white100,
        disabledActiveBg: colors.primary.primary75,
        disabledActiveBorder: colors.primary.primary75,
        controlsColor: colors.neutral.neutral40,
        controlsColorHover: colors.neutral.neutral45,
        boxShadow: '0px 7px 20px rgba(0, 0, 0, 0.08), 0px 1px 4px rgba(0, 0, 0, 0.05)'
      },
      dateDropdown: {
        text: colors.neutral.neutral80,
        label: colors.neutral.neutral45,
        bg: colors.primary.primary10,
        activeBg: colors.neutral.white100,
        border: colors.primary.primary25,
        activeBorder: colors.primary.primary100,
        disabledBg: colors.neutral.neutral5,
        disabledBorder: colors.neutral.neutral25,
        disabledLabel: colors.neutral.neutral45,
        disabledDescription: colors.neutral.neutral45,
        popoverBg: colors.primary.primary10,
        closeIcon: colors.primary.primary100,
        asteriskColor: colors.status.error100,
        errorMessage: colors.status.error100,
        errorStateBg: colors.status.error10,
        errorBorderColor: colors.status.error100,
        focusErrorBorderColor: colors.status.error100,
        placeholder: colors.neutral.neutral45,
        description: colors.neutral.neutral45,
        iconColor: colors.neutral.neutral60,
        iconFocusColor: colors.primary.primary100,
        iconDisabledColor: colors.neutral.neutral25,
        iconErrorColor: colors.status.error100
      },
      datePicker: {
        background: colors.primary.primary10,
        text: colors.neutral.neutral80,
        active: colors.primary.primary100,
        activeContrast: colors.neutral.white100,
        selected: colors.primary.primary25,
        muted: colors.neutral.neutral25,
        disabled: colors.neutral.neutral40,
        navigation: colors.neutral.neutral25,
        separator: colors.neutral.neutral10
      },
      searchInput: {
        light: {
          bg: colors.primary.primary10,
          border: colors.primary.primary25,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary100,
          clearIcon: '#9b9b9b',
          focusClearIcon: '#9b9b9b',
          searchIcon: colors.neutral.neutral60,
          focusSearchIcon: colors.primary.primary100
        },
        medium: {
          bg: colors.neutral.white100,
          border: colors.primary.primary20,
          focusBg: colors.neutral.white100,
          focusBorder: colors.primary.primary100,
          clearIcon: '#9b9b9b',
          focusClearIcon: '#9b9b9b',
          searchIcon: colors.neutral.neutral60,
          focusSearchIcon: colors.primary.primary100
        },
        dark: {
          bg: '#5485bc',
          border: '#5485bc',
          focusBg: colors.neutral.white100,
          focusBorder: colors.neutral.white100,
          clearIcon: '#fff',
          focusClearIcon: '#9b9b9b',
          searchIcon: '#fff',
          focusSearchIcon: colors.primary.primary100
        }
      },
      stepper: {
        labelActive: colors.neutral.neutral80,
        labelActiveHover: '#000',
        labelDisabled: colors.neutral.neutral15,
        labelDisabledHover: colors.neutral.neutral25,
        stepCircleLabelActive: colors.neutral.white100,
        stepCircleLabelDisabled: colors.neutral.white100,
        stepCircleActiveBg: colors.primary.primary75,
        stepCircleActiveBgHover: colors.primary.primary100,
        stepCircleDisabledBg: colors.neutral.neutral15,
        stepCircleCompletedBg: colors.primary.primary75,
        stepCircleDisabledBgHover: colors.neutral.neutral25,
        chevronActive: colors.neutral.neutral40,
        chevronDisabled: colors.neutral.neutral15
      },
      badge: {
        backgroundColor: {
          default: colors.neutral.neutral15,
          highlight: colors.primary.primary75,
          success: colors.variant.success,
          error: colors.status.error75,
          warning: colors.status.alert75,
          disabled: colors.neutral.neutral15,
          primary: colors.accent.accent75
        },
        badgeValue: {
          default: colors.neutral.neutral80,
          highlight: colors.neutral.white100,
          success: colors.neutral.white100,
          error: colors.neutral.white100,
          warning: colors.neutral.neutral80,
          disabled: colors.neutral.neutral45,
          primary: colors.neutral.neutral80
        }
      },
      textTag: {
        backgroundColor: {
          default: colors.neutral.neutral15,
          highlight: colors.primary.primary75,
          primary: colors.accent.accent75,
          success: colors.variant.success,
          error: colors.status.error75,
          warning: colors.status.alert75,
          disabled: colors.neutral.neutral15
        },
        textColor: {
          default: colors.neutral.neutral80,
          highlight: colors.neutral.white100,
          primary: colors.neutral.neutral80,
          success: colors.neutral.white100,
          error: colors.neutral.white100,
          warning: colors.neutral.neutral80,
          disabled: colors.neutral.neutral45
        }
      },
      progressBar: {
        barBackground: colors.neutral.neutral5,
        light: {
          label: colors.neutral.neutral45,
          barColor: colors.primary.primary100
        },
        dark: {
          label: colors.neutral.white100,
          barColor: colors.primary.primary75
        }
      },
      slider: {
        background: colors.neutral.neutral5,
        active: colors.primary.primary100
      },
      contentSwitcher: {
        backgroundColor: colors.neutral.neutral5,
        itemTextColor: colors.neutral.neutral80,
        selectedItemTextColor: colors.neutral.white100,
        hoverBackgroundColor: colors.neutral.neutral10,
        selectedBackgroundColor: colors.accent.accent100,
        dividerColor: colors.neutral.neutral20
      },
      chip: {
        textColor: colors.neutral.neutral80,
        background: colors.neutral.white100,
        border: colors.neutral.neutral40,
        textColorHover: colors.neutral.neutral80,
        backgroundHover: colors.neutral.neutral5,
        borderHover: colors.neutral.neutral20,
        disabledTextColor: colors.neutral.neutral45,
        disabledBackground: colors.neutral.white100,
        disabledBorder: colors.neutral.neutral20,
        selectedTextColor: colors.neutral.white100,
        selectedBackground: colors.primary.primary75,
        selectedBorder: colors.primary.primary75,
        selectedTextColorHover: colors.neutral.white100,
        selectedBackgroundHover: colors.primary.primary100,
        selectedBorderHover: colors.primary.primary100,
        selectedDisabledTextColor: colors.neutral.neutral60,
        selectedDisabledBackground: colors.neutral.neutral10,
        selectedDisabledBorder: colors.neutral.neutral10,
        closeIconColor: colors.neutral.neutral60,
        closeIconColorHover: colors.neutral.neutral80,
        selectedCloseIconColor: colors.neutral.white100,
        selectedCloseIconColorHover: colors.neutral.neutral5,
        disabledCloseIconColor: colors.neutral.neutral45,
        selectedDisabledCloseIconColor: colors.neutral.neutral60,
        leadingIconColor: colors.neutral.neutral80,
        selectedLeadingIconColor: colors.neutral.white100,
        disabledLeadingIconColor: colors.neutral.neutral45,
        selectedDisabledLeadingIconColor: colors.neutral.neutral60
      },
      iconButton: {
        iconColor: colors.neutral.neutral60,
        backgroundColor: 'transparent',
        iconHoverColor: colors.variant.primary,
        backgroundHoverColor: colors.neutral.neutral5,
        iconActiveColor: colors.variant.primary,
        backgroundActiveColor: 'transparent',
        iconDisabledColor: colors.neutral.neutral20,
        backgroundDisabledColor: 'transparent',
        iconSelectedColor: colors.variant.primary
      }
    },
    ...extra
  };
  return (0, _lodash.default)(theme, overrides);
};
exports.createPrizmTheme = createPrizmTheme;
const prizm = exports.prizm = createPrizmTheme();